import { createOnDefault } from '../chunk-ZS2PV4GN.mjs';
import { getCreateSavedSearchFromFullSearchModel, generateSavedSearchTitle, getUserInteractionData } from '../chunk-5O2ERBGA.mjs';
import { getBrandConfig, useLoadTranslations, useTranslation, isWindowUndefined, mockedBasicsKeys } from '../chunk-DBIF5UGD.mjs';
import { SavedSearchFrequency } from '@aviv-saved-search/types';
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import { useBrand } from '@aviv-unified-frontend/runtime/brand';

// src/Utils/createSavedSearch/config/common.ts
var getCreateConfig = ({ payload, configCalls }) => {
  switch (configCalls.brand) {
    case "sl":
    case "li":
    case "imn":
    case "iwt":
      return createOnDefault({ payload, configCalls });
    default:
      return Promise.resolve({ error: "Brand not supported" });
  }
};

// src/Utils/createSavedSearch/index.ts
var erroredCreateSavedSearch = (message) => ({
  createSavedSearch: async () => ({ error: message })
});
var useCreateSavedSearch = ({ page, stage }) => {
  const { id } = useBrand();
  const config = getBrandConfig(id);
  if (!config) {
    return erroredCreateSavedSearch(`${id} is not configured yet`);
  }
  if (!config.createUtils.supported) {
    return erroredCreateSavedSearch(`${id} is not supported`);
  }
  const { unsafe_accessToken } = useAuthentication();
  useLoadTranslations();
  const { t } = useTranslation();
  return {
    createSavedSearch: async ({ searchModel, email, classifiedInfo }) => {
      if (unsafe_accessToken && !config.login?.oauth) {
        return { error: `${id} is not supported for oauth` };
      }
      if (!email && !unsafe_accessToken) {
        return { error: "No email or oauthToken provided" };
      }
      if (!email && config.createUtils.emailRequired) {
        return { error: `Email is needed for ${id}` };
      }
      const configCalls = {
        basicsKeys: mockedBasicsKeys,
        stage,
        brand: config.brandId
      };
      if (!searchModel.priceMax && classifiedInfo?.price) {
        const searchedPriceMax = Math.round(classifiedInfo.price * 1.1 / 100) * 100;
        searchModel.priceMax = searchedPriceMax;
      }
      const search = getCreateSavedSearchFromFullSearchModel({
        searchModel,
        brand: config.searchBrand,
        searchType: "classified"
      });
      search.channels = search.channels?.map((channel) => ({
        ...channel,
        frequency: SavedSearchFrequency.hourly
      }));
      const title = generateSavedSearchTitle(search.criteria, t);
      const currentUrl = !isWindowUndefined() ? window?.location?.href : "";
      const userInteractionData = getUserInteractionData({
        page,
        componentId: "",
        brandId: config.brandId
      });
      const payload = {
        search,
        title,
        currentUrl,
        userInteractionData,
        email,
        oauthToken: unsafe_accessToken
      };
      const result = await getCreateConfig({ payload, configCalls });
      return result;
    }
  };
};

export { useCreateSavedSearch };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map